/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { useCallback, useEffect } from 'react';

// Util function to add an event listener
const addListener = (obj, ...args) => {
  if (obj && obj.addEventListener) {
    obj.addEventListener(...args);
  }
};

// Util function to remove an event listener
const removeListener = (obj, ...args) => {
  if (obj && obj.removeEventListener) {
    obj.removeEventListener(...args);
  }
};

// React side-effect hook that shows a (native) browser alert when user tries to reload or close the page.
// Usage: useBeforeUnload(flag, 'You have unsaved changes, are you sure?');
const useBeforeUnload = (enabled = true, message) => {

  const handler = useCallback(
    (event) => {
      const finalEnabled = typeof enabled === 'function' ? enabled() : true;

      if (!finalEnabled) {
        return;
      }

      event.preventDefault();

      if (message) {
        event.returnValue = message;
      }

      return message;
    },
    [enabled, message]
  );

  useEffect(() => {
    if (!enabled) {
      return;
    }

    addListener(window, 'beforeunload', handler);

    return () => removeListener(window, 'beforeunload', handler);
  }, [enabled, handler]);
};

export default useBeforeUnload;
